// extracted by mini-css-extract-plugin
module.exports = {"link":"_7a3fb80146--link--jojEy","statistic-item-text":"_7a3fb80146--statistic-item-text--SkTMU","arrow":"_7a3fb80146--arrow--c8b1D"};